import { NavBarItemWithLink } from '@components/Core/Navbar/types';
import LogoutIcon from '@icons/navbar/navbar_logout.svg?component';
import ProfileIcon from '@icons/navbar/navbar_profile.svg?component';
import ShopIcon from '@icons/navbar/navbar_shop.svg?component';
import BrandsIcon from '@icons/navbar/navbar_brands.svg?component';
import { NavBarItem } from './types';

export const bottomNavItems: NavBarItem[] = [
  { icon: <ProfileIcon />, label: 'profile' },
  { icon: <LogoutIcon />, label: 'logout' },
];

export const iconProps = { width: '100%', height: '100%' };

export const userNavItems: NavBarItemWithLink[] = [
  // {
  //   icon: <ShopIcon {...iconProps} />,
  //   label: 'points',
  //   link: { path: '/points', exact: true },
  //   disable: true,
  // },
  {
    icon: <BrandsIcon {...iconProps} />,
    label: 'brands',
    link: { path: '/brands', exact: true },
  },
];
